import "swiper/css";
import Icon from "../ui/Icon";
import SearchInput from "./SearchInput";
import { Link } from "react-router-dom";
import LazyImage from "../ui/LazyImage";
import { useState, useRef } from "react";
import type { HeaderProps } from "../../types";
import { useAuth } from "../../providers/AuthProvider";
import CategoriesMenuContent from "./CategoriesMenuContent";
import defaultLogo from "../../assets/images/green-logo.png";
import { useHeaderSearch } from "../../features/header/hooks/useHeaderSearch";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../components/ui/DropdownMenu";

export default function Header({ categories = [] }: HeaderProps) {
  const { user } = useAuth();

  const containerRef = useRef<HTMLDivElement>(null);
  const {
    query,
    isOpen,
    handleSearchToggle,
    handleSearchEnter,
    handleSearchChange,
    handleClearSearch,
  } = useHeaderSearch({ containerRef });
  const [isDropDownOpen, setIsDropdownOpen] = useState(false);
  const displayNickname = user?.nickname || "کاربر";
  const displayName = user?.name || "حساب کاربری";
  const displayLogo = user?.logo || defaultLogo;

  return (
    <header
      className="sticky top-0 w-full flex items-center justify-between bg-green-01/95 backdrop-blur-sm z-10 px-4 py-2 xl:!px-11 xl:py-5 2xl:p-7"
      dir="rtl"
    >
      <Link
        to="/home"
        className="flex items-center gap-2.5 group min-w-0"
        aria-label="پروفایل کاربر"
      >
        <div className="size-14 shrink-0 border-[3px] border-white group-hover:opacity-90 transition-all duration-300 shadow-sm group-hover:shadow-md overflow-hidden rounded-full bg-white">
          <LazyImage
            src={displayLogo}
            alt={displayName}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>

        <div className="hidden xl:flex gap-1.5 text-right group-hover:opacity-90 text-[16px] font-semibold transition duration-200 font-kahroba min-w-0">
          <span className="text-accent-04 flex shrink-0 items-center justify-start gap-x-0.5 leading-tight truncate max-w-[200px]">
            <h2>{displayNickname}</h2>
          </span>
          <span className="text-accent-04 shrink-0 truncate max-w-[200px]">
            {displayName}
          </span>
        </div>
      </Link>

      {/* SEARCH + MENU */}
      <div
        className={`
        flex items-center justify-end w-full xl:gap-x-1.5 transition-all duration-200
        ${isOpen
            ? "fixed inset-0 z-50 bg-green-01/95 backdrop-blur md:static md:bg-transparent md:backdrop-blur-0"
            : ""
          }
      `}
      >
        <div
          ref={containerRef}
          className={`
          flex items-center transition-all duration-300

          ${isOpen ? "w-full px-4 md:px-0" : ""}
        `}
        >
          <SearchInput
            isOpen={isOpen}
            onClose={handleClearSearch}
            searchQuery={query}
            onSearchChange={handleSearchChange}
            onEnter={handleSearchEnter}
            placeholder="جستجو در خدمات، مدیران و موسسات..."
          />
          {!isOpen && (
            <button
              onClick={handleSearchToggle}
              className="hidden xl:flex items-center justify-center size-[40px] bg-green-04 text-white hover:bg-green-05/90 hover:scale-105 active:scale-95 transition-all duration-200 shadow-sm hover:shadow-md rounded-full"
              aria-label="جستجو در صفحه"
              title="جستجو"
            >
              <Icon icon="Search" className="text-white size-[14px]" />
            </button>
          )}
        </div>
        {/* DESKTOP MENU */}
        <div className="hidden md:block">
          <DropdownMenu open={isDropDownOpen} onOpenChange={setIsDropdownOpen}>
            <DropdownMenuTrigger asChild>
              <div
                className="flex items-center justify-center data-[state=open]:bg-complement-02 text-green-04 hover:text-green-04/70 hover:bg-green-01/50 transition-all duration-200 size-10 text-sm font-kahroba cursor-pointer rounded-xl"
                aria-label="منو"
              >
                <Icon icon="Category" className="size-6" />
              </div>
            </DropdownMenuTrigger>

            <DropdownMenuContent
              className="p-2 bg-complement-02 border border- !rounded-[30px]"
              align="start"
            >
              <CategoriesMenuContent
                categories={categories}
                searchQuery={query}
                closeDropdownMenu={() => {
                  setIsDropdownOpen(false);
                }}
              />
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        {/* MOBILE MENU */}
        <div className={`md:hidden ${isOpen ? "hidden" : "flex"}`}>
          <Link
            to="/home"
            className="flex items-center justify-center data-[state=open]:bg-complement-02 text-green-04 hover:text-green-04/70 hover:bg-green-01/50 transition-all duration-200 size-10 text-sm font-kahroba rounded-xl"
            aria-label="خانه"
            title="خانه"
          >
            <Icon icon="Home" className="size-6" />
          </Link>
        </div>
        {/* <button
          className="hidden xl:flex items-center justify-start px-1 text-green-04 hover:text-green-04/70 hover:bg-green-01/50 transition-all duration-200 size-10 rounded-full"
          aria-label="دسته‌بندی‌ها"
        >
          <Icon icon="Menu" className="size-6" />
        </button> */}
        <Link
          to="/Home"
          className="hidden xl:flex items-center justify-start px-1 text-green-04 hover:text-green-04/70 hover:bg-green-01/50 transition-all duration-200 size-10 rounded-full"
        >
          <Icon icon="Home" className="size-6" />
        </Link>
      </div>
    </header>
  );
}
